export const RAW_FILES_PATH = 'https://raw.githubusercontent.com/cowprotocol/cow-sdk/refs/heads/main'
